import React, { useState } from "react";
import { AsyncTypeahead } from "react-bootstrap-typeahead";
import ApsModels from "../../../models";
import ApsServices from "../../../services";

function CourseCategoryTypeahead(props: {
  libType: ApsModels.CredLibraryTypeEnum;
  onChange: (data: any[], ref: any) => void;
}) {
  const [items, setItems] = useState([] as any[]);
  const [isLoading, setIsLoading] = useState(false);
  const ref = React.createRef<AsyncTypeahead<any>>();
  const handleSearch = async (query: string) => {
    if ((query || "").trim() === "") {
      setItems([]);
      setIsLoading(false);
      return;
    }
    setIsLoading(true);
    await ApsServices.http.credCredential
      .getCredentialCategories(props.libType)
      .then((items) => {
        const options = items.map((i) => ({
          id: i.id,
          name: `${i.name} (${i.agency} Library)`,
          model: { ...i },
        }));
        setItems(options);
        setIsLoading(false);
      })
      .catch((err) => {
        setItems([]);
        setIsLoading(false);
      });
  };

  return (
    <AsyncTypeahead
      id="basic-typeahead-search-cred-category"
      labelKey="name"
      onSearch={handleSearch}
      onChange={(data) => {
        props.onChange(data, ref);
      }}
      searchText={"Searching..."}
      isLoading={isLoading}
      options={items}
      placeholder="Search or add credential category"
      minLength={1}
      delay={500}
      useCache={false}
      ref={ref}
    />
  );
}

export default CourseCategoryTypeahead;
